import React, { Component, useEffect } from 'react';
import { observer } from "mobx-react";
import 'react-toastify/dist/ReactToastify.css';
import { Layout } from '../components/Layout';
import store from '../components/Stores/SurveyStore';
import PrivateRoute from '../Routing/PrivateRoute'
import { Route, Redirect } from 'react-router';

//The SurveyElement component is used to render input questions (ie: textinput, numinput, calculated, textarea) 
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveyContentContainer from '../components/SurveyContentContainer'

import PreviousYearDataPanel from '../components/PreviousYearDataPanel';

//Common Pages
import GenericHomePage from '../components/GenericHomePage';
import LaundromatPage from '../components/LaundromatPage';


//Modals
import HelpModal from "../components/Modals/HelpModal"
import IBSAdminPanel from "../components/Modals/IBSAdminPanel"
import AddCommentModal from "../components/Modals/AddCommentModal"
import AddExplanationModal from "../components/Modals/AddExplanationModal"


import { ToastContainer, Slide } from 'react-toastify';

import SurveyLoadingScreen from '../components/SurveyLoadingScreen'

//helper
import LogoutConfirmModal from '../components/Modals/LogoutConfirmModal';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import NavMenu from "./NavMenu";
import RecentActivitiesPage from "./RecentActivitiesPage";
import { LoadIBSSurvey, LoadIBSView, LoadDBSurvey } from '../control';
import { checkIfAnalyst } from '../Services/IBS/IbsService';
import { Link, Switch } from 'react-router-dom';


const Home = () => {
    return (
        <SurveyPage showFooter={false}>
            <SurveyTitleArea />
            <SurveyContentContainer homePage={true}>
                <GenericHomePage 
                  dueDate="April 15th, 2021" 
                  surveyCategoryName="IBS Benchmarking" 
                 contacts={[ // {
                  //       name:'Flo Vaughan',
                  //       email:'Flo@cembenchmarking.com',
                  //       phone: '416-369-1476',
                  //     },
                      {
                        name: 'Yvette Van Velsen',
                        email: 'Yvette@explorecem.com',
                        phone: '416-369-0812',
                      },
                    ]}
                />
            </SurveyContentContainer>
            
        </SurveyPage>
    );
};

const Laundromat = observer(() => {
    return (
        <SurveyPage style={{ paddingTop: '3%' }}>
            <SurveyTitleArea />
            <NavMenu />
            <div className={'left-container'}>
                <LaundromatPage />
            </div>
        </SurveyPage>
    );
});

export const IBSHomePage = observer(() => {
    //This component loads when an analyst has not beamed any survey yet
    useEffect(() => {
        LoadIBSView()
    }, []);

    return (

        <Layout>
            <Switch>
                <PrivateRoute exact path='/ibs/home' component={Home} allowClientAccess />

                <PrivateRoute exact path='/ibs/laundromat' component={LaundromatPage} />
                <PrivateRoute exact path='/ibs/recentActivities' component={RecentActivitiesPage} />

                <PrivateRoute path="*" component={Home} allowClientAccess />
            </Switch>
            <IBSAdminPanel />
            <PreviousYearDataPanel />
            <HelpModal />
            <AddCommentModal />
            <AddExplanationModal />
            <LogoutConfirmModal />
            <ToastContainer transition={Slide} />
        </Layout>
    );
});




